import { createTheme } from "@mui/material/styles";

// Crée un thème personnalisé avec la palette et la typographie
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 730, // Point de rupture que tu souhaites utiliser
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: "#4caf50", // Couleur principale (vert)
    },
    secondary: {
      main: "#2c3e50", // Couleur secondaire (noir)
    },
    background: {
      default: "#f5f5f5", // Arrière-plan par défaut (gris clair)
    },
  },
  typography: {
    fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif', // Police de caractères
    h1: {
      fontSize: "2.5rem", // Taille du titre principal
      fontWeight: "bold",
    },
    h2: {
      fontSize: "2rem", // Taille du titre secondaire
      fontWeight: "bold",
    },
    body1: {
      fontSize: "1rem", // Taille du texte standard
      lineHeight: 1.6,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px", // Bord arrondi pour les boutons
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#4caf50", // Couleur de fond de l'en-tête de la table
          color: "#fff", // Couleur du texte dans l'en-tête
        },
        body: {
          fontSize: "1rem", // Taille du texte dans le corps de la table
        },
      },
    },
  },
});

export default theme;
